"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const CopyButton = (props) => {
    const { className, tooltipDirection, onClick } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: 'd-inline', children: (0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: '\u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0', direction: tooltipDirection, children: (0, jsx_runtime_1.jsx)("i", { onClick: onClick, className: `icon-md far fa-copy pointer ${className || ''}` }) }) }));
};
exports.default = CopyButton;
